export const environment = {
  production: true,
  appVersion: 'v8.0.27',
  USERDATA_KEY: 'authf649fc9a5f55',
 
  // GraphQL & REST
  // graphqlURI: 'https://api.dev.msrestapi.com/hrms/api',
  graphqlURI: 'https://hrms-api4.0.sentrixbar.com/api',
  //  graphqlURI: 'https://api-hrms-sso.sentrixbar.com/api',
  restURI: 'https://api-hrms5.0.sentrixbar.com/',
  restV2URI: 'https://api-hrms5.0.sentrixbar.com',
  // restV2URI: 'http://10.10.10.84:5005',
  realtimeWsUri: 'wss://api-hrms5.0.sentrixbar.com',
  graphql_WS_URI: 'wss://api-hrms-sso.sentrixbar.com/api',
  googleMapsApiKey:'',
 
  // SSO
  OAUTH_API: 'https://admin.local.mobilesentrix.com',
 
  // PDF signing
  pdfSignAppUrl: 'https://pdf.sentrixbar.com',
 
  // Chat https://api.dev.msrestapi.com/hrms
  CHAT_USER_DATA_KEY: 'chat-user',
  chatUrl: 'https://api-chat.sentrixbar.com',
  wsChatUrl: 'wss://api-chat-uat.techbar.com/',
  chat_FE_URL:''
};
